import { PRIVILEGIOS } from "@/utils/privilegios";
import auth from "../middleware/auth";

const prefixoSecretaria = "/secretaria";
const privilegioSecretaria = [PRIVILEGIOS.SECRETARIA];

export default [
  {
    path: `${prefixoSecretaria}/home`,
    name: "secretaria-home",
    component: () => import("@/pages/gestor/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/perfil`,
    name: "secretaria-perfil",
    component: () => import("@/pages/gestor/Perfil.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/minhas-turmas`,
    name: "minhas-turmas",
    component: () =>
      import("../pages/professor/salaAula/MinhasTurmasInicio.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/configuracao-acesso`,
    name: "secretaria-configuracao-acesso",
    component: () => import("@/pages/gestor/cadastro/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/comunicados`,
    name: "secretaria-comunicados",
    component: () => import("@/pages/gestor/comunicados/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/livros-digitais`,
    name: "prefixo-digitais",
    component: () => import("@/pages/professor/livrosDigitais/Inicio.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  
  {
    path: `${prefixoSecretaria}/professores-turma`,
    name: "secretaria-professor-turma",
    component: () =>
      import("@/pages/gestor/professorTurma/ProfessorTurma.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  
  {
    path: `${prefixoSecretaria}/albuns`,
    name: "albuns",
    component: () => import("@/pages/professor/albuns/AlbunsInicio.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/assessoria`,
    name: "assessoria-professor",
    component: () =>
      import("@/pages/professor/assessoriaPedagogica/AssessoriaInicio.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/sala-aula/escola/:id_escola/turma/:id_turma`,
    name: "sala-aula-secretaria",
    component: () => import("@/pages/gestor/salaAula/MainSalaAula.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/sala-professores`,
    name: "sala-professores",
    component: () =>
      import("@/pages/gestor/salaProfessores/SalaProfessoresInicio.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/agenda`,
    name: "secretaria-agenda",
    component: () => import("@/pages/gestor/agenda/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/cadastro/boletim`,
    name: "secretaria-cadastro-professor",
    component: () => import("@/pages/gestor/cadastro/boletim/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/recursos-educacionais`,
    name: "recursos-educacionais",
    component: () =>
      import("@/pages/professor/recursosEducacionais/RecursosEducacionaisInicio.vue"
      ),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },

    {
      path: `${prefixoSecretaria}/recursos-educacionais/disciplinas`,
      name: "disciplinas",
      component: () =>
        import("@/pages/professor/recursosEducacionais/caminho/DisciplinasInicio.vue"
          ),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
  
    {
      path: `${prefixoSecretaria}/recursos-educacionais/video/disciplina/:id_disciplina`,
      name: "material-videos",
      component: () =>
        import("@/pages/professor/recursosEducacionais/videos/VideosInicio.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
  
    {
      path: `${prefixoSecretaria}/recursos-educacionais/:tipo/disciplina/:id_disciplina`,
      name: "material-recursos-educacionais",
      component: () =>
        import("@/pages/professor/recursosEducacionais/caminho/AnosInicio.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/recursos-educacionais/material/:tipo/assistir`,
      name: "videoaulas-assuntos",
      component: () =>
        import("@/pages/professor/recursosEducacionais/videoaulasAnimacoes/AssistirVideoAulas.vue"
          ),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/videoaulas/disciplina/:id_disciplina/ano/:id_ano/assistir-videoaula/:id_video?`,
      name: "assistir-videoaula",
      component: () =>
        import("@/pages/professor/recursosEducacionais/videoaulasAnimacoes/AssistirVideoAulas.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/recursos-educacionais/infograficos-mapas`,
      name: "infograficos-mapas",
      component: () =>
        import("@/pages/professor/recursosEducacionais/infograficosMapas/InfograficosMapasInicio.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
  
    {
      path: `${prefixoSecretaria}/recursos-educacionais/educacao-interativa`,
      name: "educacao-interativa",
      component: () =>
        import("@/pages/professor/recursosEducacionais/educacaoInterativa/EducacaoInterativaInicio.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/recursos-educacionais/educacao-interativa/sistema-solar`,
      name: "sistema-solar",
      component: () =>
        import("@/pages/professor/recursosEducacionais/educacaoInterativa/cards/SistemaSolar.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/recursos-educacionais/educacao-interativa/corpo-humano`,
      name: "corpo-humano",
      component: () =>
        import("@/pages/professor/recursosEducacionais/educacaoInterativa/cards/CorpoHumano.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/recursos-educacionais/educacao-interativa/evo-historia`,
      name: "evo-historia",
      component: () =>
        import("@/pages/professor/recursosEducacionais/educacaoInterativa/cards/EvoHistoria.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/recursos-educacionais/educacao-interativa/evo-atlas`,
      name: "evo-atlas",
      component: () =>
        import("@/pages/professor/recursosEducacionais/educacaoInterativa/cards/EvoAtlas.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/recursos-educacionais/educacao-interativa/evo-quimica`,
      name: "evo-quimica",
      component: () =>
        import("@/pages/professor/recursosEducacionais/educacaoInterativa/cards/EvoQuimica.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/recursos-educacionais/educacao-interativa/evo-games`,
      name: "evo-games",
      component: () =>
        import("@/pages/professor/recursosEducacionais/educacaoInterativa/cards/EvoGames.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/recursos-educacionais/educacao-interativa/evo-quiz`,
      name: "evo-quiz",
      component: () =>
        import("@/pages/professor/recursosEducacionais/educacaoInterativa/cards/EvoQuiz.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
  
    {
      path: `${prefixoSecretaria}/recursos-educacionais/podcast`,
      name: "podcast",
      component: () =>
        import("@/pages/professor/recursosEducacionais/podcast/PodcastInicio.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/recursos-educacionais/audios-ingles`,
      name: "audios-ingles",
      component: () =>
        import("@/pages/professor/recursosEducacionais/audiosIngles/AudiosInglesInicio.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/recursos-educacionais/audios-infantis`,
      name: "audios-infantis",
      component: () =>
        import("@/pages/professor/recursosEducacionais/audiosInfantis/AudiosInfantisInicio.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/recursos-educacionais/planejamento`,
      name: "planejamento-professor",
      component: () =>
        import("@/pages/professor/recursosEducacionais/planejamento/PlanejamentoInicio.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/recursos-educacionais/sequencia/:id_disciplina`,
      name: "material-sequencia-didatica",
      component: () =>
        import("@/pages/professor/recursosEducacionais/sequenciaDidatica/SequenciaDidaticaInicio.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/recursos-educacionais/projeto-integrador/:id_disciplina`,
      name: "projeto-integrador",
      component: () =>
        import("@/pages/professor/recursosEducacionais/projetosIntegradores/ProjetosIntegradoresInicio.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/recursos-educacionais/conteudo-aberto`,
      name: "conteudo-aberto",
      component: () =>
        import("@/pages/professor/recursosEducacionais/ConteudoAberto/ConteudoAbertoHome.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },
    {
      path: `${prefixoSecretaria}/recursos-educacionais/conteudo-aberto/:id_disciplina`,
      name: "conteudo-aberto-disciplina",
      component: () =>
        import("@/pages/professor/recursosEducacionais/ConteudoAberto/ConteudoAbertoDisciplina.vue"),
      beforeEnter: auth,
      meta: {
        id_privilegio: privilegioSecretaria,
      },
    },

  {
    path: `${prefixoSecretaria}/relatorio/acessos`,
    name: "secretaria-relatorio-acesso",
    component: () => import("@/pages/gestor/relatorio/acessos/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/relatorio/bimestral`,
    name: "secretaria-relatorio-bimestral",
    component: () => import("@/pages/gestor/relatorio/bimestral/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/relatorio/avaliacoes`,
    name: "secretaria-relatorio-acesso-avaliacoes",
    component: () => import("@/pages/gestor/relatorio/avaliacao/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/ver/turmas/:professor`,
    name: "secretaria-ver-turmas-professor",
    component: () => import("@/pages/gestor/professorTurma/VerTurmas.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/ver/turma/:turma/:escola/:professor`,
    name: "secretaria-ver-turma-professor",
    component: () => import("@/pages/gestor/professorTurma/VerTurma.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/marketing-educacional`,
    name: "secretaria-marketing-educacional",
    component: () =>
      import("@/pages/gestor/pecasComunicacao/PecasComunicacaoInicio.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/issuu`,
    name: "LivrosEmbedIssuuGestor",
    ttl: "LivrosEmbedIssuuGestor",
    icon: "mdi-home-outline",
    meta: {
      id_privilegio: privilegioSecretaria,
    },
    component: () => import("@/pages/gestor/LivrosEmbedIssuu.vue"),
    menu: false,
  },
  {
    path: `${prefixoSecretaria}/avaliacoes-old`,
    name: "AvaliacoesGestor",
    component: () => import("@/pages/gestor/avaliacoes/Inicio.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/avaliacao-old/criar/:id_avaliacao?`,
    name: "AvaliacoesCriarGestor",
    component: () => import("@/pages/gestor/avaliacoes/criar/CriarInicio.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/avaliacoes/:id_avaliacao/imprimir`,
    name: "imprimir-avaliacoes-secretaria",
    component: () =>
      import("@/pages/professor/seusArquivos/avaliacoes/imprimir/ImprimirInicio.vue"),
    beforeEnter: auth,
    meta: { id_privilegio: privilegioSecretaria },
  },
  {
    path: `${prefixoSecretaria}/avaliacoes`,
    name: "AvaliacoesGestorDemo",
    component: () => import("@/pages/gestor/avaliacoes/InicioNovo.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/avaliacao/criar/:id_avaliacao?`,
    name: "editar-avaliacao-secretaria",
    component: () =>
      import("@/pages/professor/seusArquivos/novaAvaliacao/criar/CriarInicio.vue"),
    beforeEnter: auth,
    meta: { id_privilegio: privilegioSecretaria },
  },
  {
    path: `${prefixoSecretaria}/avaliacoes/:id_avaliacao/aplicacao/:id_aplicacao/inserir-respostas`,
    name: "inserir-respostas-aplicacao-secretaria-nova",
    component: () =>
      import("@/pages/professor/seusArquivos/novaAvaliacao/inserirRespostasAplicacao/Home.vue"),
    beforeEnter: auth,
    meta: { id_privilegio: privilegioSecretaria },
  },
  {
    path: `${prefixoSecretaria}/avaliacoes/:id_avaliacao/aplicacao/:id_aplicacao/inserir-respostas/turma/:id_turma/aluno/:id_aluno`,
    name: "inserir-respostas-aplicacao-aluno-secretaria-nova",
    component: () =>
      import("@/pages/professor/seusArquivos/novaAvaliacao/inserirRespostasAplicacao/aluno/Home.vue"),
    beforeEnter: auth,
    meta: { id_privilegio: privilegioSecretaria },
  },
  {
    path: `${prefixoSecretaria}/atividades`,
    name: "AtividadesGestor",
    component: () => import("@/pages/gestor/atividades/Inicio.vue"),
    beforeEnter: auth,
    meta: { id_privilegio: privilegioSecretaria },
  },
  {
    path: `${prefixoSecretaria}/atividade/criar/:id_atividade?`,
    name: "criar-atividade-secretaria",
    component: () =>
      import("@/pages/professor/seusArquivos/atividades/criar/CriarInicio.vue"),
    beforeEnter: auth,
    meta: { id_privilegio: privilegioSecretaria },
  },
  {
    path: `${prefixoSecretaria}/avaliacoes/:id_avaliacao?`,
    name: "seus-arquivos-atividades-avaliacoes-secretaria",
    component: () =>
      import("@/pages/professor/seusArquivos/novaAvaliacao/aplicacao/Inicio.vue"),
    beforeEnter: auth,
    meta: { id_privilegio: privilegioSecretaria },
  },
  {
    path: `${prefixoSecretaria}/avaliacoes/aplicacao/:id_avaliacao?/imprimir/:id_aplicacao`,
    name: "imprimir-avaliacoes-secretaria-aplicacao",
    component: () =>
      import("@/pages/professor/seusArquivos/novaAvaliacao/imprimir/ImprimirInicio.vue"),
    beforeEnter: auth,
    meta: { id_privilegio: privilegioSecretaria },
  },
  {
    path: `${prefixoSecretaria}/atividades/:id_atividade/imprimir`,
    name: "imprimir-atividade-secretaria",
    component: () =>
      import("@/pages/professor/seusArquivos/atividades/imprimir/ImprimirInicio.vue"),
    beforeEnter: auth,
    meta: { id_privilegio: privilegioSecretaria },
  },
  {
    path: `${prefixoSecretaria}/atividades/:id_atividade/acompanhamento`,
    name: "acompanhamento-atividade-secretaria",
    component: () =>
      import("@/pages/professor/seusArquivos/atividades/acompanhamento/Inicio.vue"),
    beforeEnter: auth,
    meta: { id_privilegio: privilegioSecretaria },
  },
  {
    path: `${prefixoSecretaria}/configuracao-acesso`,
    name: "secretaria-configuracao-acesso",
    component: () => import("@/pages/gestor/cadastro/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
  {
    path: `${prefixoSecretaria}/avaliacoes/:id_avaliacao/aplicacao/:id_aplicacao/inserir-respostas`,
    name: "inserir-respostas-aplicacao-secretaria",
    component: () =>
      import("@/pages/professor/seusArquivos/novaAvaliacao/inserirRespostasAplicacao/Home.vue"),
    beforeEnter: auth,
    meta: { id_privilegio: privilegioSecretaria },
  },
  {
    path: `${prefixoSecretaria}/avaliacoes/:id_avaliacao/aplicacao/:id_aplicacao/inserir-respostas/turma/:id_turma/aluno/:id_aluno`,
    name: "inserir-respostas-aplicacao-aluno-secretaria",
    component: () =>
      import("@/pages/professor/seusArquivos/novaAvaliacao/inserirRespostasAplicacao/aluno/Home.vue"),
    beforeEnter: auth,
    meta: { id_privilegio: privilegioSecretaria },
  },
  {
    path: `${prefixoSecretaria}/avaliacao/criar/:id_avaliacao?`,
    name: "criar-avaliacao-secretaria",
    component: () =>
      import("@/pages/professor/seusArquivos/novaAvaliacao/criar/CriarInicio.vue"),
    beforeEnter: auth,
    meta: { id_privilegio: privilegioSecretaria },
  },
  {
    path: `${prefixoSecretaria}/avaliacoes/:id_avaliacao/aplicacao/:id_aplicacao/acompanhamento/nova-remediacao`,
    name: "acompanhamento-aplicacao-secretaria",
    component: () =>
      import("@/pages/professor/seusArquivos/avaliacoes/acompanhamento-novo/aplicacao/Inicio.vue"),
    beforeEnter: auth,
    meta: { id_privilegio: privilegioSecretaria },
  },
  {
    path: `${prefixoSecretaria}/atividade/:id_avaliacao/aplicacao/:id_aplicacao/acompanhamento/:id_aluno/visualizacao`,
    name: "remediacao-ver-atividade-secretaria",
    component: () => import(
      '@/pages/professor/seusArquivos/avaliacoes/acompanhamento-novo/aplicacao/visualizar/Inicio.vue'
    ),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria
    }
  },
  {
    path: `${prefixoSecretaria}/faq`,
    name: "faq-secretaria",
    component: () => import("@/pages/professor/faqProfessor/faqProfessor.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioSecretaria,
    },
  },
];
